import React, { useRef, useEffect } from 'react';
import { IoSend } from 'react-icons/io5';
import { InputContainer, Input, SendButton } from '../../styles/ChatStyles';

const ChatInput = ({ 
  input, 
  setInput, 
  handleSend, 
  isTyping, 
  config 
}) => {
  const inputRef = useRef(null);

  // Add effect to auto-resize input when value changes programmatically
  // useEffect(() => {
  //   if (inputRef.current) {
  //     inputRef.current.style.height = 'auto';
  //     inputRef.current.style.height = Math.min(inputRef.current.scrollHeight, 120) + 'px';
  //   }
  // }, [input]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey && input.trim()) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleInput = (e) => {
    setInput(e.target.value);
    e.target.style.height = 'auto';
    e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
  };

  const handleClick = () => {
    if (input.trim()) {
      handleSend();
    }
  };

  return (
    <InputContainer>
      <Input
        ref={inputRef}
        value={input}
        onChange={handleInput}
        onKeyPress={handleKeyPress}
        placeholder={isTyping ? "Vui lòng đợi trợ lý AI trả lời..." : config.chat_message_placeholder}
        fontSize={config.fontSize}
        disabled={isTyping}
        rows={1}
      />
      <SendButton 
        onClick={handleClick}
        disabled={!input.trim() || isTyping}
        data-loading={isTyping}
        whileHover={{ scale: input.trim() && !isTyping ? 1.05 : 1 }}
        whileTap={{ scale: input.trim() && !isTyping ? 0.95 : 1 }}
        initial={false}
        animate={{
          scale: 1,
          transition: { duration: 0 }
        }}
        type="button"
        title={isTyping ? "Vui lòng đợi trợ lý AI trả lời..." : "Gửi tin nhắn"}
      >
        <IoSend />
      </SendButton>
    </InputContainer>
  );
};

export default ChatInput;